import React from 'react';

export const CalculationContext = React.createContext({});
export const useCalculation = () => React.useContext(CalculationContext);
